import { render } from "./ExcludeProductModal.vue?vue&type=template&id=e8abc666&scoped=true"
import script from "./ExcludeProductModal.vue?vue&type=script&lang=js"
export * from "./ExcludeProductModal.vue?vue&type=script&lang=js"

import "./ExcludeProductModal.vue?vue&type=style&index=0&id=e8abc666&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8abc666"]])

export default __exports__